import { useEffect, useState } from 'react';
import { Button, Modal } from '../components/ui';
import '../components/ui/common.css';
import { badHabitsAPI, settingsAPI } from '../services/api';

const BadHabits = () => {
    const [habits, setHabits] = useState([]);
    const [summary, setSummary] = useState([]);
    const [types, setTypes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingHabit, setEditingHabit] = useState(null);
    const [formData, setFormData] = useState({ habitTypeId: '', quantity: '', date: '' });

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        try {
            const [habitsRes, summaryRes, typesRes] = await Promise.all([
                badHabitsAPI.getAll(),
                badHabitsAPI.getSummary(),
                settingsAPI.getBadHabitTypes()
            ]);
            setHabits(habitsRes.data);
            setSummary(summaryRes.data);
            setTypes(typesRes.data);
        } catch (error) {
            console.error('Error loading data:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (editingHabit) {
                await badHabitsAPI.update(editingHabit.id, formData);
            } else {
                await badHabitsAPI.create(formData);
            }
            setModalOpen(false);
            setEditingHabit(null);
            setFormData({ habitTypeId: '', quantity: '', date: '' });
            loadData();
        } catch (error) {
            console.error('Error saving habit:', error);
            alert('Ошибка при сохранении');
        }
    };

    const handleEdit = (habit) => {
        setEditingHabit(habit);
        setFormData({
            habitTypeId: habit.habitTypeId,
            quantity: habit.quantity,
            date: habit.date.split('T')[0]
        });
        setModalOpen(true);
    };

    const handleDelete = async (id) => {
        if (!window.confirm('Удалить запись?')) return;
        try {
            await badHabitsAPI.delete(id);
            loadData();
        } catch (error) {
            console.error('Error deleting habit:', error);
            alert('Ошибка при удалении');
        }
    };

    const openAddModal = () => {
        setEditingHabit(null);
        setFormData({
            habitTypeId: types.length > 0 ? types[0].id : '',
            quantity: '',
            date: new Date().toISOString().split('T')[0]
        });
        setModalOpen(true);
    };

    if (loading) {
        return <div className="loading">Загрузка...</div>;
    }

    return (
        <div>
            <div className="page-header">
                <h1>Негативные привычки</h1>
                <Button onClick={openAddModal}>+ Добавить</Button>
            </div>

            {summary.length > 0 && (
                <div className="summary-grid">
                    {summary.map((item) => (
                        <div key={item.habitTypeId} className="summary-card">
                            <div className="summary-label">{item.habitType?.name || '—'}</div>
                            <div className="summary-value">{item.totalQuantity} ед.</div>
                        </div>
                    ))}
                </div>
            )}

            {habits.length === 0 ? (
                <div className="empty-state">
                    <div className="empty-state-icon">📊</div>
                    <p>Нет записей</p>
                    <Button onClick={openAddModal}>Добавить первую запись</Button>
                </div>
            ) : (
                <div>
                    {habits.map((habit) => (
                        <div key={habit.id} className="list-item">
                            <div className="list-item-content">
                                <div style={{ fontSize: '1.25rem', fontWeight: '600' }}>
                                    {habit.habitType?.name || '—'} — {habit.quantity} ед.
                                </div>
                                <div style={{ color: 'var(--text-secondary)', fontSize: '0.875rem' }}>
                                    {new Date(habit.date).toLocaleDateString('ru-RU')}
                                </div>
                            </div>
                            <div className="list-item-actions">
                                <button className="icon-btn" onClick={() => handleEdit(habit)}>✏️</button>
                                <button className="icon-btn" onClick={() => handleDelete(habit.id)}>🗑️</button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <Modal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                title={editingHabit ? 'Редактировать запись' : 'Добавить запись'}
                footer={
                    <>
                        <Button variant="secondary" onClick={() => setModalOpen(false)}>Отмена</Button>
                        <Button onClick={handleSubmit}>Сохранить</Button>
                    </>
                }
            >
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="habitTypeId">Тип привычки</label>
                        <select
                            id="habitTypeId"
                            value={formData.habitTypeId}
                            onChange={(e) => setFormData({ ...formData, habitTypeId: e.target.value })}
                            required
                        >
                            <option value="">Выберите тип</option>
                            {types.map((type) => (
                                <option key={type.id} value={type.id}>{type.name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="quantity">Количество (единиц)</label>
                        <input
                            id="quantity"
                            type="number"
                            min="1"
                            value={formData.quantity}
                            onChange={(e) => setFormData({ ...formData, quantity: e.target.value })}
                            required
                            placeholder="10"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="date">Дата</label>
                        <input
                            id="date"
                            type="date"
                            value={formData.date}
                            onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                            required
                        />
                    </div>
                </form>
            </Modal>
        </div>
    );
};

export default BadHabits;
